module.exports = __webpack_public_path__ + "img/bookcases-and-cabinets.3344386.jpg";